export const gridCellBaseStyle = {
  width: "113%",
  padding: "2px 4px",
  display: "flex",
  alignItems: "center",
  marginRight: "-8px",
  height: "35px",
  float: "inline-end",
} as const;

export const gridCellErrorStyle = {
  border: "1px solid red",
} as const;

export const gridCellNormalStyle = {
  border: "1px solid transparent",
} as const;

export const editIconStyle = {
  fontSize: "inherit",
  verticalAlign: "middle",
  color: "rgb(19, 18, 18)",
  marginBottom: "13px",
  height: "12px",
  cursor: "pointer",
} as const;
